/** @format */

export const PLP_CONSTANTS: { appPathPrefix: string } = {
  appPathPrefix: 'f',
};
